import { GxCheckbox, GxIcon } from '@garpix/garpix-web-components-react'
import { checkIcon } from '@/images'
import classNames from 'classnames'
import React from 'react'
import style from './styles/checkbox.module.scss'

const Checkbox = ({
  children,
  theme = 'gray',
  className = '',
  ...props
}): React.ReactElement => {
  return (
    <GxCheckbox
      className={classNames({
        [style.default]: true,
        [style[`theme_${theme}`]]: Boolean(theme),
        [className]: Boolean(className)
      })}
      {...props}
    >
      {children}
      <GxIcon src={checkIcon} className={style.icon} slot='checked-icon' />
    </GxCheckbox>
  )
}

export default Checkbox
